// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app---3vTSy{height:100vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.footer---NcHZ2{-ms-flex-negative:0;flex-shrink:0;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}.footer---NcHZ2 p{font-size:16px !important;font-weight:500 !important;padding-top:5px;padding-left:6px !important}.container-wrapper---3U5Hh{height:calc(100vh - 120px);position:relative;margin-bottom:0.01px !important;border-radius:5px 5px 0.01px 0.01px;min-width:1242px}@media screen and (max-width: 1220px){.container-wrapper---3U5Hh{margin:0.001px !important}}.footer---NcHZ2>*{margin:0 8px}\n", ""]);
// Exports
exports.locals = {
	"app": "app---3vTSy",
	"footer": "footer---NcHZ2",
	"container-wrapper": "container-wrapper---3U5Hh"
};
module.exports = exports;
